<template>
  <section class="hero section-cta">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-vcentered">
          <div class="column">
            <p class="title">
              <slot name="title"></slot>
            </p>
            <p class="product-cta">
              <Button :to="{ name: 'contact' }" size="large">
                <slot name="button">Contact Us</slot>
              </Button>
            </p>
          </div>
          <div class="column is-narrow">
            <div class="image-wrapper">
              <slot name="image"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Button from '@/components/Button'

export default {
  name: 'section-contact',

  components: {
    Button
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SectionContact.vue